<template>
  <div>
    <form  v-if="!isMobile" v-bind:class="{ 'o-form__pc-bottom': !minial }"  method="post" action="/register" @submit.prevent="handleSubmit" ref="form">
      <slot></slot>
      <p v-bind:class="{ 'center o-form__pc-bottom__title': !minial, 'title center': minial }" class="">簡単無料登録</p>
      <div v-bind:class="{ 'o-form__pc-bottom__content': !minial, 'form__detail': minial }"class="">
        <text-input-group
            v-model="form.params.name"
            :error="error.first('name')"
            type="text"
            placeholder="例）田中　悠人"
            label="お名前"
            name="name"
            :required="true"
            :minial="minial"
          />

          <text-input-group
            v-model="form.params.name_kana"
            :error="error.first('name_kana')"
            type="text"
            placeholder="例）たなか　ゆうと"
            label="よみがな"
            name="name_kana"
            :required="true"
            :minial="minial"
          />

          <text-input-group
            v-model="form.params.email"
            :error="error.first('email')"
            type="text"
            placeholder="例）eigyo@commitgrowth.co.jp"
            label="メールアドレス"
            name="email"
            :required="true"
            :minial="minial"
          />

          <text-input-group
            v-model="form.params.tel"
            :error="error.first('tel')"
            type="text"
            placeholder="例）090-1234-5678"
            label="電話番号"
            name="tel"
            :required="true"
            :minial="minial"
          />

        <p v-if="!minial" class="description">※ご登録後自動返信メールが送信されますので、utopia@commitgrowth.co.jpを受信できるように設定お願い致します。</p>

        <label v-if="!minial" class="description"><input type="checkbox" v-model="checked">「<a href="/privacypolicy" target="_blank" rel="noopener noreferrer">個人情報の取り扱い</a>」「<a href="/userpolicy" target="_blank" rel="noopener noreferrer">利用規約</a>」に同意の上、同意して無料登録ボタンをクリックしてください。</label>

        <label v-if="minial" class="description"><input type="checkbox" v-model="checked">「<a href="/privacypolicy" target="_blank" rel="noopener noreferrer">個人情報の取り扱い</a>」「<a href="/userpolicy" target="_blank" rel="noopener noreferrer">利用規約</a>」に同意の上、同意して無料登録ボタンをクリックしてください。</label>

        <div class="submit">
          <input type="submit" value="同意して無料登録" :disabled="!checked">
        </div>
      </div>
    </form>

    <div v-if="isMobile" class="o-form__sp__bottom">
        <p class="title center">簡単無料登録</p>
        <form class="o-form__sp-bottom" v-bind:class="{ 'is-modal': isModal }" method="post" action="/register" @submit.prevent="handleSubmit" ref="form">
          <slot></slot>
          <text-input-group
            v-model="form.params.name"
            :error="error.first('name')"
            type="text"
            placeholder="例）田中　悠人"
            label="お名前"
            name="name"
            :required="true"
            :minial="minial"
            :is-mobile="isMobile"
          />

          <text-input-group
            v-model="form.params.name_kana"
            :error="error.first('name_kana')"
            type="text"
            placeholder="例）たなか　ゆうと"
            label="よみがな"
            name="name_kana"
            :required="true"
            :minial="minial"
            :is-mobile="isMobile"
          />

          <text-input-group
            v-model="form.params.email"
            :error="error.first('email')"
            type="text"
            placeholder="例）eigyo@commitgrowth.co.jp"
            label="メールアドレス"
            name="email"
            :required="true"
            :minial="minial"
            :is-mobile="isMobile"
          />

          <text-input-group
            v-model="form.params.tel"
            :error="error.first('tel')"
            type="text"
            placeholder="例）090-1234-5678"
            label="電話番号"
            name="tel"
            :required="true"
            :minial="minial"
            :is-mobile="isMobile"
          />
          <p class="o-form__sp-bottom__description">
            ※ご登録後自動返信メールが送信されますので、utopia@commitgrowth.co.jpを受信できるように設定お願い致します。
          </p>
          <div class="o-form__sp-bottom__detail">
            <label class="center">
              <input type="checkbox" v-model="checked">
              <span>「<a href="/privacypolicy" target="_blank" rel="noopener noreferrer">個人情報の取り扱い</a>」「<a href="/userpolicy" target="_blank" rel="noopener noreferrer">利用規約</a>」に同意します。</span>
            </label>
          </div>
          <div class="o-form__sp-bottom__submit">
            <input type="submit" value="同意して無料登録" :disabled="!checked">
          </div>
        </form>
    </div>
  </div>
</template>


<script>
import Errors from "@/utils/Errors";
import Form from "@/utils/Form";
import Panel from '@/shared/Panel/Panel'
import PanelHeader from '@/shared/Panel/PanelHeader'
import PanelBody from '@/shared/Panel/PanelBody'
import PanelFooter from '@/shared/Panel/PanelFooter'
import TextInputGroup from '@/shared/Input/TextInputGroup'
import TextAreaGroup from '@/shared/Input/TextAreaGroup'

export default {
  props: {
    data: {
      type: Array | Object | null,
      default: null,
      required: false,
    },
    jobId: {
      type: Number,
      required: false,
    },
    errors: {
      type: Array | Object | null,
      default: null,
      required: false,
    },
    minial: {
      type: Boolean | null,
      default: false,
      required: false,
    },
    isMobile: {
      type: Boolean,
      default: false,
      required: false,
    },
    isModal: {
      type: Boolean,
      default: false,
      required: false,
    },
    isAjax: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  components: {
    Panel,
    PanelHeader,
    PanelBody,
    PanelFooter,
    TextInputGroup,
    TextAreaGroup
  },
  data() {
    return {
      error: new Errors(this.errors ? this.errors : []),
      form: new Form(!this.data || (this.data && this.data.length === 0) ? {
        name: '',
        name_kana: '',
        email: '',
        tel: ''
      } : this.data ),
      sending: false,
      checked: false,
    }
  },
  methods: {
    handleSubmit () {
      if (!this.isAjax) {
        this.$refs.form.submit();
      } else {
        if (this.sending) {
          return;
        }
        this.sending = true;
        this.form
            .post({
              url: "/job/register/" + this.jobId,
            })
            .then((res) => {
              this.isSuccess = true;
              setTimeout(() => this.isSuccess = false, 5000);
              this.sending = false;
              flash(res.data.message, 'success')
              $('.js-modal-close').click();
              window.scrollTo(0, 0)
            })
            .catch((error) => {
              this.error = this.form.errors
              this.sending = false;
            });
      }
    },
  },
  mounted() {
  },
  computed: {
  }
}
</script>
